import ReactDatePicker from 'react-date-picker';
import styled, { css } from 'styled-components';

export const StyledReactDatePicker = styled(ReactDatePicker)`
  --kp-datepicker-icon: ${({ theme }) => theme.colors.secondary400};
  --kp-datepicker-icon-hover: ${({ theme }) => theme.colors.secondary600};
  --kp-datepicker-outline: ${({ theme }) => theme.colors.secondary500};
  --kp-datepicker-active: ${({ theme }) => theme.colors.primary500};
  --kp-datepicker-active-hover: ${({ theme }) => theme.colors.primary600};
  --kp-datepicker-surface-card: ${({ theme }) =>
    theme.colors.semantic.surface.card};
  --kp-datepicker-surface-muted: ${({ theme }) =>
    theme.colors.semantic.surface.muted};
  --kp-datepicker-text-primary: ${({ theme }) =>
    theme.colors.semantic.text.primary};
  --kp-datepicker-text-secondary: ${({ theme }) =>
    theme.colors.semantic.text.secondary};
  --kp-datepicker-border: ${({ theme }) =>
    theme.colors.semantic.border.default};
  --kp-datepicker-now: ${({ theme }) => theme.colors.semantic.surface.muted};
  --kp-datepicker-now-hover: ${({ theme }) =>
    theme.colors.semantic.surface.card};
  --kp-datepicker-disabled-bg: ${({ theme }) =>
    theme.colors.semantic.surface.muted};
  --kp-datepicker-disabled-border: ${({ theme }) =>
    theme.colors.semantic.border.subtle};

  &.react-date-picker {
    width: 100%;
    background-color: var(--kp-datepicker-surface-card);
    border: 1px solid var(--kp-datepicker-border);
    border-radius: 8px;
  }

  .react-date-picker__wrapper {
    border: none;
    background-color: var(--kp-datepicker-surface-card);
  }

  .react-date-picker__inputGroup,
  .react-date-picker__inputGroup__input,
  .react-date-picker__inputGroup__divider,
  .react-date-picker__inputGroup__leadingZero,
  .react-date-picker__button {
    color: var(--kp-datepicker-text-primary);
  }

  .react-date-picker__inputGroup__input::placeholder {
    color: var(--kp-datepicker-text-secondary);
  }

  .react-date-picker__calendar-button,
  .react-date-picker__clear-button {
    background-color: var(--kp-datepicker-surface-card);
  }

  .react-date-picker__calendar {
    inset: calc(100% + 4px) auto auto 0 !important;
  }

  .react-calendar {
    background-color: var(--kp-datepicker-surface-card);
    border: 1px solid var(--kp-datepicker-border);
    color: var(--kp-datepicker-text-primary);
  }

  .react-calendar button {
    color: var(--kp-datepicker-text-primary);
  }

  .react-calendar__navigation button {
    background-color: var(--kp-datepicker-surface-card);
  }

  .react-calendar__navigation button:enabled:hover,
  .react-calendar__navigation button:enabled:focus,
  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus {
    background-color: var(--kp-datepicker-surface-muted);
  }

  .react-calendar__month-view__weekdays,
  .react-calendar__month-view__days__day--neighboringMonth {
    color: var(--kp-datepicker-text-secondary);
  }

  ${props =>
    props.$invalid &&
    css`
      border-color: ${props.theme.colors.dangerPrimary};
    `}
`;
